import { array } from 'fp-ts';
import { Source, CommanderThunkAction, AsyncAction } from '@mews-commander/types';
import { createFetchAction } from '@mews-commander/utils';
import { setSources } from '../ducks/sources';
import prefix from '../prefix';

const SOURCES_FETCH = prefix('SOURCES_FETCH');

export const fetch =
    (): CommanderThunkAction<AsyncAction> =>
    async (dispatch, getState, { container }) => {
        const promise = container()
            .sourcesComponent.getAll()
            .then(({ sources }: { sources: Array<Source> }) => {
                if (array.isNonEmpty(sources)) {
                    dispatch(setSources(sources));
                }
            });

        return dispatch(createFetchAction(SOURCES_FETCH, promise));
    };

export const fetchSource = () => fetch();
